import type { RefinementListItem } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList';
import { FormattedMessage } from 'react-intl';

import { GameplayTierStars } from '@sorare/core/src/components/card/GameplayTierStars';
import { FILTERS } from '@sorare/core/src/lib/filters';
import {
  isGameplayTier,
  sortByGameplayTier,
} from '@sorare/core/src/lib/gameplayTiers';

import { makeBackendFilter } from '#src/searchCards/RefineList/index.tsx';

const sortItems = (items: RefinementListItem[]) => [
  ...items.sort((a, b) => sortByGameplayTier(a.value, b.value)),
];

const renderBefore = (o: string) =>
  isGameplayTier(o) ? (
    <GameplayTierStars gameplayTier={o} />
  ) : (
    <FormattedMessage defaultMessage="Unknown" />
  );

export const RefineBackendGameplayTier = ({
  hideTitle,
}: { hideTitle?: boolean } = {}) =>
  makeBackendFilter(FILTERS.gameplayTier, {
    formatOption: () => '',
    transformItems: sortItems,
    renderBefore,
    hideTitle,
  });
